import React from 'react';
import { H5, H6, UL, LI } from '../../AbstractElements';
import { QuickAccessData } from '../../Data/FileManager';

const QuickAccess = () => {
  return (
    <>
      <H5>Quick Access </H5>
      <UL className='quick-file d-flex flex-row'>
        {QuickAccessData.map((item, i) => (
          <LI key={i}>
            <div className='quick-box'>{item.icon}</div>
            <H6>{item.title}</H6>
          </LI>
        ))}
      </UL>
    </>
  );
};

export default QuickAccess;
